import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carlos M.',
    location: 'Houston, TX',
    quote: 'Pasé de ser rechazado para un auto usado a tener un score de 740 en 4 meses. El protocolo de limpieza de crédito es oro puro. Ya no pido favores, exijo tasas.',
    initial: 'C'
  }, {
    name: 'Marisol R.',
    location: 'Miami, FL',
    quote: 'Siempre pensé que invertir era para ricos. Recibir mi primer dividendo de $45 dólares de una empresa que uso todos los días me voló la cabeza. El Código cambia vidas.',
    initial: 'M'
  }, {
    name: 'Javier T.',
    location: 'Los Angeles, CA',
    quote: 'Dejé de pagarle la hipoteca a mi landlord. Usé la estrategia FHA que explican aquí y acabo de cerrar mi primer duplex. Vivo en uno y rento el otro. Libertad.',
    initial: 'J'
  }];
  return <section className="py-24 bg-navy-950 relative" data-id="element-193">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-194">
        <FadeIn className="text-center mb-16" data-id="element-195">
          <h2 className="text-4xl font-bold font-serif mb-4" data-id="element-196">
            La Nueva Realidad
          </h2>
          <p className="text-gray-400" data-id="element-197">
            Resultados reales de quienes ya tienen El Código.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-198">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-199">
              <div className="bg-navy-900 border border-navy-800 p-8 rounded-2xl relative h-full flex flex-col" data-id="element-200">
                <Quote className="absolute top-6 right-6 w-8 h-8 text-navy-700" data-id="element-201" />
                <p className="text-gray-300 mb-8 relative z-10 flex-grow italic font-light" data-id="element-202">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-4 mt-auto" data-id="element-203">
                  <div className="w-12 h-12 rounded-full bg-navy-800 border border-gold-500/30 flex items-center justify-center text-gold-400 font-serif text-xl" data-id="element-204">
                    {testimonial.initial}
                  </div>
                  <div data-id="element-205">
                    <div className="text-white font-medium" data-id="element-206">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-207">
                      {testimonial.location}
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}